<app-banner [heading]="'DANCE STUDIO'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
		   <section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6 ">
            <img src="assets/img/infra/dancestudio/dance-studio-1.jpg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6  pt-5 pt-lg-0">
             <h6 class="">Performing Arts @ TGS</h6>
              
              <p>At Tagore Global School Kurukshetra, Students are provided with spacious dance studio.<br><br> 
			  Students are trained in Indian Traditional/Western Dance form. <br><br>We believe that apart from nurturing talent, 
			  Indian Music is important for children to be firmly rooted to India’s culture and heritage.
			  
			  </p>
             
			 <br><br>
		  
        </div>
      </div>
    </div></section><!-- End Features Section -->
	
		  
		 
		  
		
      
	
    

    
	
	
    
    
  </main>